import * as $ from 'jquery';
import * as React from "react";
import ReactHtmlParser from 'react-html-parser';
import { Link } from "react-router-dom";

export class FormControllerHelper {
    static showOrHideBlockOnSummarySteps(pageWithOnly1Step: boolean, isSummaryStep: boolean) {
        if (pageWithOnly1Step !== undefined && 
            isSummaryStep && 
            !pageWithOnly1Step) {
          $(`.mijn-fnv .mainBlock .mijn-fnv-form__content-block, 
          .mijn-fnv .mainBlock .content__callout--widget`).addClass("hidden");
        } else {
          $(`.mijn-fnv .mainBlock .mijn-fnv-form__content-block, 
          .mijn-fnv .mainBlock .content__callout--widget`).removeClass("hidden");
        }
    }

    static renderSummaryIntro(summaryIntro) {
      const summaryIntroElement = ReactHtmlParser(summaryIntro, {
        transform: (node, index) => {
          if (node.type === 'tag' && node.name === 'a' && node.attribs && node.attribs["data-mijnfnv-link"]) {
            return <Link className="link__single" key={"summaryintro-" + index} to={node.attribs["data-mijnfnv-link"]}>{node.children.map((nodeChild, childrenIndex) => {
              return <React.Fragment key={"sum-child-" + index}>{nodeChild.data && nodeChild.type == "text" ? nodeChild.data : null}</React.Fragment>;
            })}<span className="icon icon-open-chevron-right"></span></Link>;
          }
      }});

      return <div className="form-summary__intro">{summaryIntroElement}</div>;
    }

    static showOrHideBackLink(isVisible : boolean) {
      if (isVisible) {
        $(".link__back-to-mijnfnv").removeClass("hidden");
      } else {
        $(".link__back-to-mijnfnv").addClass("hidden");
      }
    } 

    static getFieldsMapper(formFieldDefinitions: any, formController : any, formValues: any, formDefinitions : any) {
      let fieldsMapper = {};      
     
      // TODO : code minimaliseren met functies
      (formFieldDefinitions || []).map((fieldDefinition) => {
          if (fieldDefinition.id !== undefined && !fieldsMapper[fieldDefinition.id]) {
              Object.defineProperty(fieldsMapper, fieldDefinition.id, {
                  get: () => {
                      if (formController._formikBag && formController._formikBag.values) {
                        const valueObject = formController._formikBag.values[fieldDefinition.name];

                        if (valueObject === undefined) {
                          return {
                            Value : ""
                          };
                        }

                        let value : any = "";
                        if (valueObject !== null && valueObject !== undefined) {
                            if (valueObject.value !== undefined) {
                                value = valueObject.value || "";
                            } else {
                                value = valueObject || "";
                            }
                        }

                        // workaround for kentico macro evaluation of booleans via Fields[...].Value
                        if (value === true) {
                          value = "True";
                        }
                        if (value === false) {
                          value = "False";
                        }
                        return {
                            Value: value
                        };
                      } else {
                        return {
                          Value: ""
                      };
                    } 
                  }
              });

              if(fieldsMapper[fieldDefinition.name] === undefined){
                Object.defineProperty(fieldsMapper, fieldDefinition.name, {
                  get: () => {
                    // TODO : refactor naar method
                      if (formController._formikBag && formController._formikBag.values) {
                        const valueObject : any = formController._formikBag.values[fieldDefinition.name];
                                                
                        let value : any = "";
                        if (valueObject !== null && valueObject !== undefined) {
                            if (valueObject.value !== undefined) {
                                value = valueObject.value || "";
                            } else {
                                value = valueObject || "";
                            }
                        }

                        // workaround for kentico macro evaluation of booleans via Fields[...].Value
                        if (value === true || value === "true") {
                          value = "True";
                        }
                        if (value === false || value === "false") {
                          value = "False";
                        }

                        return {
                            Value: value
                        };
                      } else {
                        return {
                          Value: ""
                        };
                      }
                  }
              });
              }
          }
      });

      for (let form in formDefinitions) {
        if (formDefinitions.hasOwnProperty(form)) {

          formDefinitions[form].map((fieldDefinition) => {
            if (fieldsMapper[fieldDefinition.name] === undefined && 
                formValues[form] !== undefined &&
                formValues[form][fieldDefinition.name] !== undefined) {              
                            
              Object.defineProperty(fieldsMapper, fieldDefinition.name, {
                get: () => {
                  // TODO : refactor naar method
                    const valueObject : any = formValues[form][fieldDefinition.name];
                    if (valueObject === undefined) {
                      return {
                        Value : ""
                      };
                    }
                    let value : any = "";
                    if (valueObject !== null && valueObject !== undefined) {
                        if (valueObject.value !== undefined) {
                            value = valueObject.value || "";
                        } else {
                            value = valueObject || "";
                        }
                    }

                    // workaround for kentico macro evaluation of booleans via Fields[...].Value
                    if (value === true || value === "true") {
                      value = "True";
                    }
                    if (value === false || value === "false") {
                      value = "False";
                    }
                    
                    return {
                        Value: value
                    };
                }
              });
            }
          });
        }
      }      

      return fieldsMapper;
    }
}